import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { dataGuard } from './core/guards/data-ready.guard';
import { loginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth/auth-callback/auth-callback.component').then(c => c.AuthCallbackComponent),
  },
  {
    path: 'auth/logout',
    loadComponent: () => import('./auth/auth-logout/auth-logout.component').then(c => c.AuthLogoutComponent),
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/forbidden/forbidden.component').then(c => c.ForbiddenComponent),
  },
  {
    path: '',
    loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(c => c.DashboardComponent),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Dashboard',
  },
  {
    path: 'trends-insights',
    loadComponent: () => import('./pages/trends-insights/trends-insights.component').then(c => c.TrendsInsightsComponent),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Trends Insights',
  },
  {
    path: 'requests/:type',
    loadComponent: () => import('./pages/requests/requests.component').then(c => c.RequestsComponent),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Requests',
  },
  {
    path: 'request',
    loadChildren: () => import('./pages/request/request.route'),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
  },
  {
    path: 'view-request/:id',
    redirectTo: 'request/view/:id',
  },
  {
    path: 'reports',
    loadComponent: () => import('./pages/reports/reports.component').then(c => c.ReportsComponent),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Reports',
  },
  {
    path: 'boards',
    loadComponent: () => import('./pages/boards/boards.component').then(c => c.BoardsComponent),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Boards',
  },
  {
    path: 'notifications',
    loadComponent: () => import('./pages/notifications/notifications.component').then(c => c.NotificationsComponent),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Notifications',
  },
  {
    path: 'insights-matrix',
    loadChildren: () => import('./pages/insights-matrix/insights-matrix.routes'),
    canActivate: [autoLoginPartialRoutesGuard, dataGuard],
    title: 'Avion Service Desk - Insights Matrix',
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.component').then(c => c.NotFoundComponent),
  },
];
